import { createApiClient } from '@avrahami/ui';

/** The app's API client (same origin, session cookie; see `@avrahami/ui`). */
export const api = createApiClient();
